export default __webpack_public_path__ + "static/media/icon_guide_step_uns.f3aafc19.svg";